import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { selectReportRequestState } from '../selectors/report-request.selectors';
import { loadReportRequestData } from '../actions/report-request.actions';

@Injectable()
export class ReportRequestFacade {
    
    constructor(private store: Store<IAppState>) {
    }

    getReportRequestData() {
        this.store.dispatch(loadReportRequestData());
    }

    getReportRequestState() {
        return this.store.pipe(select(selectReportRequestState));
    }
}
